import React from 'react';
import Sidebar from './Components/SideBar';
import Hero from './sections/Hero';
import CEOMessage from './Components/SEOMessage';
import Services from './sections/Services';
import Portfolio from './sections/Portfolio';
import StatsCounter from './Components/StatsCounter';
import Testimonials from './sections/Testimonials';
import Contact from './sections/Contact';
import Footer from './Components/Footer';
import FloatingContact from './sections/FloatingContact';
import './index.css';

function App() {
  return (
    /* Change 1: 'relative' ensures the floating elements and sidebar 
       position themselves correctly. 
    */
    <div className="relative min-h-screen bg-white">
      
      <Sidebar />

      {/* Change 2: Removing 'flex' from the parent and using 
         responsive padding/margin on the main content.
         - On mobile: No left margin (ml-0).
         - On Desktop: Margin left (lg:ml-20) to make room for the fixed sidebar.
      */}
      <main className="w-full lg:ml-20 ml-0 transition-all duration-300">
        <Hero />
        <Services />
        <Portfolio />
        <CEOMessage />
        <StatsCounter />
        <Testimonials />
        <Contact />
        <Footer />
        <FloatingContact />
      </main>
    </div>
  );
}

export default App;